module.exports = __webpack_public_path__ + "img/Download.b646ba9c.png";